export const AUTH_TOKEN_KEY = 'auth_token';

function requestUrl(input: RequestInfo | URL): string {
  if (typeof input === 'string') return input;
  if (input instanceof URL) return input.href;
  return input.url;
}

/**
 * Gắn token đăng nhập vào mọi request tới API HomeTools cùng origin.
 * Cài một lần trước khi render để cả request đầu tiên của các trang cũng có token.
 */
export function installAuthFetch(): void {
  const originalFetch = window.fetch.bind(window);
  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    const target = new URL(requestUrl(input), window.location.origin);
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    if (!token || target.origin !== window.location.origin || !target.pathname.startsWith('/api/')) {
      return originalFetch(input, init);
    }
    const headers = new Headers(init?.headers ?? (input instanceof Request ? input.headers : undefined));
    if (!headers.has('Authorization')) headers.set('Authorization', `Bearer ${token}`);
    return originalFetch(input, { ...init, headers });
  };
}

/** Tải file cần đăng nhập (vd. ảnh CCCD) thành object URL để hiển thị trong <img>. */
export async function fetchProtectedObjectUrl(url: string): Promise<string | null> {
  try {
    const response = await fetch(url);
    if (!response.ok) return null;
    return URL.createObjectURL(await response.blob());
  } catch {
    return null;
  }
}
